import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AddProductToCart, ClearCart } from './cart.actions';
import { CartItem, createCartItem } from './cart.model';

export class CartStateModel {
  items: CartItem[]= [];
  total: number;
}

@State<CartStateModel>({
  name: 'CartStateModel',
  defaults: new CartStateModel()
})
@Injectable()
export class CartState {
  constructor() {}

  @Selector()
  static items(state: CartStateModel): CartItem[] {
    return state.items;
  }

  @Selector()
  static total(state: CartStateModel): number {
    return state.items.reduce((accumulator, current) => {
      return accumulator + (current.total as number);
    }, 0);
  }

  @Action(AddProductToCart)
  onAddProductToCart(
    { getState, patchState }: StateContext<CartStateModel>,
    { data }: AddProductToCart
  ) {

    const item = createCartItem({
      productId: data.id,
      title: data.title,
      description: data.description,
      unitPrice: data.unitPrice,
      quantity: data.quantity,
      total : data.totalPrice
    });

    patchState({ items: getState().items.concat(item) });
  }


  @Action(ClearCart)
  onClearCart(
    {  patchState }: StateContext<CartStateModel>,
    { }: ClearCart
  ) {

    patchState({ items: [] });
  }
}
